<template>
<div id="shopping-cart">
    <div class="container">

        <cart></cart>

        <div class="row buttonContainer">
            <div class="col-6">
                <button type="button" class="btn btn-outline-medium-gray" @click.prevent="back">
                    <i class="icon icon-arrow-back"></i> {{$t('cart.checkout.back_to_shop')}}
                </button>
            </div>
            <div class="col-6 text-right">
                <transition name="fade">
                    <button type="button" class="btn btn-green" v-if="items.length && showNextButton" @click.prevent="step = 2">
                        {{$t('cart.checkout.next')}} <i class="icon icon-arrow-forward"></i>
                    </button>
                </transition>
            </div>
        </div>

        <template v-if="showUserSection">
            <user key="user" @register="setRigistrationType"></user>
            <register key="register" :type="registerType" v-if="showRegisterForm"></register>
        </template>

        <template v-if="showCheckoutSection">
            <shipping></shipping>

            <hr class="wide">
            <payment></payment>
            <hr class="wide">

            <!-- <overview></overview> -->

            <div class="checkout-data">
              <input type="hidden" name="isGuest" :value="user.id > 1000000000" />
              <input type="hidden" name="guestId" :value="user.id" v-if="user.id > 1000000000" />
              <input type="hidden" name="altDelivery" :value="useAlt" />
              <template v-if="useAlt">
                <template v-for="(value, key) in altShipping">
                  <input type="hidden" :name="`altAddress[${key}]`" :value="value" :key="`altAddress[${key}]`" />
                </template>
              </template>
            </div>

            <!-- <br><br> -->
            <!-- <div class="row justify-content-center" v-html="checkout.form"></div> -->
            <div class="row justify-content-center">
              <div class="col-sm-3">
                <button type="submit" class="btn btn-lg btn-green w-100">{{$t('cart.checkout.order_overview_btn')}}</button>
              </div>
            </div>
        </template>

    </div>
</div>
</template>

<script>
import Vue from 'vue'
import Modules from '@Components/checkout/modules'
import { createNamespacedHelpers as nsHelper } from 'vuex'
import SmoothScroll from 'smooth-scroll'

const scroll = new SmoothScroll()

const {
  mapState: mapUserState,
  mapActions: mapUserActions,
  mapGetters: mapUserGetters
} = nsHelper('user')

const {
  mapState: mapPaymentState
} = nsHelper('cart/payment')

const {
  mapState: mapShippingtState
} = nsHelper('cart/shipping')

const {
  mapState: mapCartState
} = nsHelper('cart')

export default {

  components: Modules,

  data () {
    return {
      step: 1,
      registerType: null
    }
  },

  computed: {
    ...mapShippingtState(['useAlt', 'altShipping']),
    ...mapPaymentState(['option', 'checkout']),
    ...mapUserGetters(['loggedIn', 'isGuest']),
    ...mapCartState(['items']),
    ...mapUserState(['user']),

    showUserSection () {
      return !this.loggedIn && this.step > 1
    },

    showRegisterForm () {
      return this.registerType
    },

    showCheckoutSection () {
      return this.loggedIn
    },

    showNextButton () {
      return this.step < 2 && !this.loggedIn
    }

  },

  methods: {

    ...mapUserActions(['getUser']),

    back () {
      window.history.back()
    },

    setRigistrationType ({ type }) {
      this.registerType = type
    }

  },

  created () {
    this.getUser()
  },

  watch: {
    step: function (val) {
      Vue.nextTick(() => {
        if (val === 2) {
          var el = document.querySelector('.shopping-cart--user .frameTitleGreen')
          scroll.animateScroll(el, null, {
            offset: anchor => document.body.className === 'is-scrolling' ? 125 : 175
          })
        }
      })
    },
    loggedIn: function (val) {
      Vue.nextTick(() => {
        if (val) {
          setTimeout(() => {
            var el = document.querySelector('.shopping-cart--shipping .checkoutTitle')
            scroll.animateScroll(el, null, {
              offset: anchor => document.body.className === 'is-scrolling' ? 125 : 175
            })
          }, 300)
        }
      })
    }
  }

}
</script>
